import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

type RadioItem = {
  label: string;
  id?: number | string;
  value: number | string;
  name: any;
};

export interface MxRadioProps {
  items: RadioItem[];
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  direction?: "row" | "column";
  label?: string;
  name?: string;
  value?: string | number;
  inputRef?: React.Ref<HTMLInputElement>;
  invalid?: boolean;
  disabled?: boolean;
}

const MxRadio: React.FC<MxRadioProps> = ({
  items,
  onChange,
  onBlur,
  direction = "row",
  label,
  name = "radio-buttons-group",
  value,
  inputRef,
  invalid,
  disabled
}) => {
  return (
    <FormControl error={invalid} disabled={disabled}>
      {label && <FormLabel id={`${name}-label`}>{label}</FormLabel>}
      <RadioGroup
        row={direction === "row"}
        aria-labelledby={`${name}-label`}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
      >
        {items.map((item, index) => (
          <FormControlLabel
            key={item.id || index}
            value={item.value}
            control={<Radio inputRef={inputRef} />}
            label={item.label}
            disabled={item.name === "disabled" || disabled}
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: "13.5px",
                fontWeight: 400
              }
            }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default MxRadio;
